import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { Entities } from 'src/common';
import AdminOperatorSupportBillingOperatorSelection from 'src/components/admin/operator-support-billing/components/admin-operator-support-billing-operator-selection';

class AdminOperatorSupportBillingAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    componentWillMount() {
        this.props.fetchAll(Entities.BUS_COMPANY);
    }

    render() {
        return (
            <div>
                {!this.props.busCompanies.isFetching ? (
                    <AdminOperatorSupportBillingOperatorSelection
                        operatorSupportBillingItems={this.props.operatorSupportBillingItems}
                        search={this.props.search}
                        busCompanies={this.props.busCompanies.items}
                        patch={this.props.patch}
                        deleteById={this.props.deleteById}
                        addErrorNotification={this.props.addErrorNotification}
                        addNotification={this.props.addNotification}
                    />
                ) : null}
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(AdminOperatorSupportBillingAdministration));
